// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"App_mainWrapper__3XP2F","pageWrapper":"App_pageWrapper__1Jej4","sidebarCollapsed":"App_sidebarCollapsed__1z5Xd"};